export const HIGHLIGHT_LAYER_PREFIX = 'highlight-';
export const LABEL_LAYER_PREFIX = 'label-';
export const POLYGON_OUTLINE_LAYER_PREFIX = 'polygon-outline-';
export const POLYGON_FILL_LAYER_PREFIX = 'polygon-fill-';
export const GL_DRAW_LAYER_PREFIX = 'gl-draw-';
export const SNAP_LAYER_PREFIX = '_snap';
export const RASTER_LAYER_PREFIX = 'raster-backup-';
export const DASHED_LINE_PREFIX = 'dashed-line-';
export const CIRCLE_LAYER_PREFIX = 'circle-';

export const EXTERNAL_VECTOR_SOURCE_PREFIX = 'external-vector-source';
export const EXTERNAL_GEOJSON_SOURCE_PREFIX = 'external-geojson-source';

export const HIGHLIGHT_SOURCE = 'highlighted-features';
export const HIGHLIGHT_FILL_SOURCE = 'highlighted-fill-features';

export const SORT_ANCHOR_SOURCE = 'sort-anchors';
export const AFTER_FEATURES_LAYER = 'after-features';
export const AFTER_HIGHLIGHTS_LAYER = 'after-highlights';
export const AFTER_LABELS_LAYER = 'after-labels';

export const DEFAULT_HIGHLIGHT_COLOR = '#FF0';
export const DEFAULT_POLYGON_HIGHLIGHT_OPACITY = 0.5;
export const FONT_NAME = 'icomoon2';

export const DEFAULT_MIN_ZOOM_TO_VIEW_LABELS = 13;
export const SATELLITE_BASEMAP = 'satelliteStreets';
export const AVAILABLE_MAPBOX_BASEMAPS = ['basic', 'streets', 'light', 'dark'];
export const DEFAULT_MIN_ZOOM = 1;
export const DEFAULT_MAX_ZOOM = 22;

export const ZOOM_SCALE_DEFAULTS = {
  POINT: {
    minFraction: 1 / 2,
    minZoom: 8,
    maxZoom: DEFAULT_MAX_ZOOM,
  },
  LINE: {
    minFraction: 1 / 3,
    minZoom: 4,
    maxZoom: 14,
  },
};

export const MAP_DEFAULTS = {
  INITIAL_ZOOM: 13,
  STYLE: 'basic',
  INITIAL_CENTER: ['-70.2568', '43.6591'], // PORTLAND, ME <3
  BASEMAPS: ['basic', 'streets', 'light', 'dark'], // aka, styles
};

// https://gis.stackexchange.com/questions/398348/mapbox-map-with-no-style-only-self-hosted-vector-data
// Style taken from https://github.com/mapbox/mapbox-gl-styles/blob/master/styles/empty-v8.json
const NONE_STYLE = {
  version: 8,
  name: 'Empty',
  metadata: {
    'mapbox:autocomposite': true,
  },
  // https://stackoverflow.com/questions/71433750/use-of-text-field-requires-a-style-glyphs-property-when-using-a-plain-back
  glyphs: 'mapbox://fonts/nbtsolutions/{fontstack}/{range}.pbf',
  sources: {},
  layers: [
    {
      id: 'background',
      type: 'background',
      paint: {
        'background-color': 'rgba(0,0,0,0)',
      },
    },
  ],
};

export const MAP_STYLE_DICT = {
  basic: 'mapbox://styles/nbtsolutions/ckgr1erhe2n6z19mwmer9jsjx?optimize=true', // BasicV2 in studio.mapbox.com
  streets: 'mapbox://styles/nbtsolutions/ckgqu41hn5w8i19s7tnw2q320?optimize=true',
  [SATELLITE_BASEMAP]: 'mapbox://styles/nbtsolutions/ckgqu4oir4r6419mi951aezqn?optimize=true',
  light: 'mapbox://styles/nbtsolutions/ckgqu4e9x2dku19qmnj4dpwtt?optimize=true',
  dark: 'mapbox://styles/nbtsolutions/ckgqu4y9o3tzj1amqs6uyz20g?optimize=true',
  none: NONE_STYLE,
};

export const ICON_CONTENT_MAP = {
  vetro: '\ue900',
  loop: '\ue911',
  office: '\ue912',
  'tower-b': '\ue919',
  tower: '\ue910',
  'line-dotted': '\ue913',
  line: '\ue914',
  house: '\ue915',
  'house-o': '\ue916',
  star: '\ue901',
  'star-o': '\ue902',
  octagon: '\ue91a',
  'octagon-o': '\ue917',
  hexagon: '\ue903',
  'hexagon-o': '\ue904',
  'hexagon-b': '\ue905',
  'hexagon-o-b': '\ue906',
  pentagon: '\ue907',
  'pentagon-o': '\ue908',
  diamond: '\ue909',
  'diamond-o': '\ue90a',
  square: '\ue90b',
  'square-o': '\ue90c',
  triangle: '\ue90d',
  'triangle-o': '\ue90e',
  circle: '\ue90f',
  'circle-o': '\ue918',
  'triangle-b': '\ue91e',
  'triangle-c': '\ue91f',
  'triangle-o-b': '\ue920',
  'triangle-o-c': '\ue921',
  'trapezoid-b': '\ue92a',
  'trapezoid-c': '\ue929',
  coil: '\ue91d',
  bowtie: '\ue925',
  infinity: '\ue927',
  'infinity-b': '\ue928',
  note: '\ue92b',
};

export const LABEL_TEXT_FONTS = {
  Regular: ['Arial Unicode MS Regular'],
  Bold: ['Arial Unicode MS Bold'],
  Italic: ['DIN Offc Pro Italic'],
};

export const CONDITIONAL_OPERATORS = {
  LT: '<',
  GT: '>',
  LTE: '<=',
  GTE: '>=',
  EQUALS: '==',
};

export const FEATURE_STATUS_ID = 'status_id';
